import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CookiePolicy from "./pages/CookiePolicy";
import AppPrivacyPolicy from "./pages/AppPrivacyPolicy";
import AppTermsConditions from "./pages/AppTermsConditions";
import AppCookiePolicy from "./pages/AppCookiePolicy";
import DeleteAccount from "./pages/DeleteAccount";
import Download from "./pages/Download";
import NotFoundPage from "./pages/NotFoundPage";
import { SiteLangProvider } from "./lib/siteLang";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function App() {
  return (
    <SiteLangProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/cookie" element={<CookiePolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/app-privacy" element={<AppPrivacyPolicy />} />
        <Route path="/app-terms" element={<AppTermsConditions />} />
        <Route path="/app-cookie" element={<AppCookiePolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/download" element={<Download />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
    </SiteLangProvider>
  );
}

export default App;
